import {DocumentForm} from './document-form.models';
import _ from 'lodash';

export class Document {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {boolean} */
    isActive = false;

    /** @type {boolean} */
    isRequired = false;

    /** @type {string} */
    pdf = '';

    /** @type {string} */
    video = '';

    /** @type {string} */
    category = '';

    /** @type {string} */
    createdAt = '';

    /** @type {string} */
    updatedAt = '';

    /** @type {DocumentForm} */
    documentForm = null;

    /** @type {boolean} */
    isPassed = false;

    /** @type {?object} - latest result from the user .. */
    latestUserResult = null;

    /**
     * @param {Object} obj
     * @returns {Document}
     */
    static fromArray(obj) {
        const clonedObj = _.cloneDeep(obj);
      
        clonedObj.documentForm = DocumentForm.fromArray(clonedObj.documentForm);

        if (clonedObj.documentForm && clonedObj.documentForm.documentFormResults && clonedObj.documentForm.documentFormResults.length) {
            clonedObj.isPassed = clonedObj.documentForm.documentFormResults.some(result => result.isPassed);

            // get last one lol
            const [latest] = clonedObj.documentForm.documentFormResults.slice(-1);
            clonedObj.latestUserResult = latest;
        }

        return Object.assign(new this, clonedObj || {});
    }
}